module.exports = __webpack_public_path__ + "static/img/warning.fd3aec43.png";